<template>
  <div class="container__menu">
    <MenuOptions />
  </div>
</template>

<script>
import MenuOptions from "./MenuOptions/MenuOptions";
export default {
  components: { MenuOptions },
};
</script>

<style scoped>
.container__menu {
  width: 100%;
  max-width: 1200px;  
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;
}

@media screen and (min-width: 1200px) {
  .container__menu {
    padding: 0;
  }
}
</style>